import { Injectable, signal } from '@angular/core';

export type ProfondeurActuelle = '01' | '02' | 'Sequence';

@Injectable({
  providedIn: 'root',
})
export class ParcoursStateService {
  private readonly _profondeurActuelle = signal<ProfondeurActuelle>('01');

  readonly profondeurActuelle = this._profondeurActuelle.asReadonly();

  setProfondeurActuelle(nouveauNiveau: ProfondeurActuelle) {
    this._profondeurActuelle.set(nouveauNiveau);
  }
}
